export interface IMinimizedExerciseMaterialProps {
    onDragEnd?: () => void;
    disabled?: boolean;
}

export const MIN_EXERCISE_MATERIAL_DRAG_TYPE = 'MIN_EXERCISE_MATERIAL_DRAG_TYPE';
